module.exports = __webpack_public_path__ + "static/media/Gallery_Grid_4-min.3ee6152a.jpg";